import { getAgeFromDdn } from "./age.js";
import { isAncienPatient } from "./ancienPatient.js";
import { getDefaultRecommendationSettings } from "./recommendationSettings.js";
export const computeDuree = (motifs, selectedPatientsObj, dureeMiniRdv, dureeDefautRdv, now, dureeFicheAppel, profile = getDefaultRecommendationSettings().durationProfiles.cadendar) => {
    if (!selectedPatientsObj || selectedPatientsObj.length === 0) {
        throw new Error("no patient in computeDuree");
    }
    if (dureeFicheAppel) {
        return dureeFicheAppel;
    }
    if (selectedPatientsObj.length > 1) {
        return ((profile.multiplePatients.enabled ? dureeMiniRdv : dureeDefautRdv) *
            selectedPatientsObj.length);
    }
    if (!selectedPatientsObj[0].birthdate) {
        return dureeDefautRdv;
    }
    if (profile.minor.enabled &&
        Math.floor(getAgeFromDdn(selectedPatientsObj[0].birthdate, now)) <=
            profile.minor.maxAge) {
        return dureeMiniRdv;
    }
    if (isAncienPatient(selectedPatientsObj[0])) {
        if (profile.existingPatientShortMotifs.enabled &&
            motifs.length === 1 &&
            profile.existingPatientShortMotifs.motifs.includes(motifs[0])) {
            return dureeMiniRdv;
        }
    }
    return dureeDefautRdv;
};
//# sourceMappingURL=computeDuree.js.map